import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Inject,
  PLATFORM_ID,
  Renderer2,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '@env/environment';
import { AppBarComponent } from '@shared/components/app-bar/app-bar.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppBarComponent, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class App implements AfterViewInit {
  constructor(@Inject(PLATFORM_ID) private platformId: object, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const loader = this.renderer.selectRootElement('.loader');
      if (loader.style.display != 'none') {
        loader.style.display = 'none';
      }
    }
  }
}
